$(document).ready(function () {
    util.init();
});


var isIpad = navigator.userAgent.match(/iPad/i) != null;
var isIphone = navigator.userAgent.match(/iPhone/i) != null;
var isIE = navigator.userAgent.match(/msie/i) != null;
var isIE7 = (navigator.appVersion.indexOf("MSIE 7.") != -1) /*($.browser.msie && parseInt($.browser.version, 10) == 7)*/;
var isIE9 = (navigator.appVersion.indexOf("MSIE 9.") != -1) /*($.browser.msie && parseInt($.browser.version, 10) == 9)*/;


function isTouchDevice() {
    return "ontouchstart" in window;
}

var hasTouch = isTouchDevice();


/*******************************************************************************
util
*******************************************************************************/

var utilFired = false;

function util() {

    var self = this;

    this.init = function () {

        if (utilFired === false) {

            utilFired = true;

            try {

                for (u in this) {

                    if (u != 'init' && self[u]['init'])
                        eval('util.' + u + '.init();');
                }

            }

            catch (e) {

            }
        }


        /* ensure top menu click events in ie7 */
        if ($.browser.msie && $.browser.version == "7.0") {
            $('#mainNav img.icon').click(function (e) {
                e.preventDefault();
                var anc = $(this).parent().parent();
                //perform redirect only if SetConfirm is undefined
                if (typeof(SetConfirm) != 'function') {
                    $(window.location).attr('href', anc.attr('href'));
                }
            });
        }

    };

};


/*****************************
*     AUTO-LOAD CLASSES
*****************************/

util.prototype.autoLoadClasses = {

    init: function () {

        if (isIE9) {
            $('.button').wrap('<div class="buttonMask" />');

            $('.buttonMask').each(function () {

                var button = $(this).find('.button');

                $(this).css({
                    'marginTop': button.css('margin-top'),
                    'marginBottom': button.css('margin-Bottom'),
                    'marginLeft': button.css('margin-left'),
                    'marginRight': button.css('margin-right'),
                    'float': button.css('float'),
                    'display': button.css('display')
                });

                button.css({
                    'marginTop': 0,
                    'marginBottom': 0,
                    'marginLeft': 0,
                    'marginRight': 0,
                    'float': 'none'
                });
            });
        }

    }
};

/*****************************
*     ADJUST ORDERBOX INPUT
*****************************/

util.prototype.adjustOrderbox = {

    init: function () {
        if ($('.orderBox').length > 0) {

            $('.orderBox').each(function () {
                var totalWidth = $(this).find('label').width();
                var textWidth = $(this).find('label span').width();
                var inputWidth = totalWidth - textWidth - 45; //2*15 px margin, 2*5px padding, 2*1px border, 3px puffer

                $(this).find('.textfield').css('width', inputWidth + 'px');

            });

        }

    }
};


/*****************************
*     ADJUST TextBox HEIGHTS
*****************************/
util.prototype.adjustTextboxHeight = function () {
    $(".autoHeightOnLoad").each(function () {
        var el = $(this);
        if ($(el)[0].scrollHeight > $(el).height() && $(el).is(":visible")) {
            $(el).height($(el)[0].scrollHeight);
        }
    })
}

/*****************************
*     ADJUST TEASER HEIGHTS
*****************************/

util.prototype.adjustTeaser = {

    init: function () {

        if ($('.teaserRow').length > 0) {

            $(window).load(function () {
                $('.teaserRow').each(function () {
                    //only adjust height of teasers if the current teaser row is not hidden; otherwise height would be 0px
                    if (!$(this).hasClass('additionalHidden') && $(this).is(":visible")) {
                        var maxHeight = 0;
                        var teaser = $(this).find('.contentBox');

                        teaser.each(function () {
                            var height = $(this).height();
                            if (height > maxHeight) maxHeight = height;
                        });

                        teaser.each(function () {
                            $(this).css('height', maxHeight + 'px');
                        });
                    }
                });

            });

        }
    },

    redo: function () {

        if ($('.teaserRow').length > 0) {

            $('.teaserRow').each(function () {
                //only adjust height of teasers if the current teaser row is not hidden; otherwise height would be 0px
                if (!$(this).hasClass('additionalHidden')) {
                    var maxHeight = 0;
                    var teaser = $(this).find('.contentBox');

                    teaser.each(function () {
                        var height = $(this).height();
                        if (height > maxHeight) maxHeight = height;
                    });

                    teaser.each(function () {
                        $(this).css('height', maxHeight + 'px');
                    });
                }
            });

        }
    }

};

/*****************************
*     ADJUST MAINNAV HEIGHTS
*****************************/

util.prototype.adjustMainnav = {

    init: function () {

        if ($('#mainNav').length > 0) {
            var maxHeight = 0;

            var link = $('#mainNav li a');

            link.each(function () {
                var height = $(this).height();
                if (height > maxHeight) maxHeight = height;
            });

            link.each(function () {
                $(this).css('height', maxHeight + 'px');
            });

        }
    }
};

/*******************************************************************************
tab box
*******************************************************************************/

//util.prototype.tabBox = {

//    init: function () {

//        if ($('.tabbox').length > 0) {

//            $('.tabbox').find('.tab').hide();
//            $('.tabbox').find('.tab.active').show();

//            $('.tabLink').each(function () {
//                var twoLine = false;
//                var content = $(this).html();

//                if ($(this).find('br').length > 0 || content.length > 14) {
//                    $(this).addClass('twoliner');
//                }

//            });

//            $('.tabLink').click(function () {

//                if (!$(this).hasClass('active')) {
//                    var tabBox = $(this).parents('.tabbox');
//                    var tabID = $(this).attr('href');

//                    tabBox.find('.tabLink.active').removeClass('active');
//                    $(this).addClass('active');

//                    tabBox.find('.tab.active').hide().removeClass('active');

//                    $(tabID).show().addClass('active');
//                }

//                return false;
//            });
//        }

//    }

//};

var util = new util();




/** 
* Returns true if the user hit Esc or navigated away from the
* current page before an AJAX call was done. (The response
* headers will be null or empty, depending on the browser.) 
* 
* NOTE: this function is only meaningful when called from 
* inside an AJAX "error" callback! 
* 
* The 'xhr' param is an XMLHttpRequest instance. 
*/
//function userAborted(xhr) {
//    return !xhr.getAllResponseHeaders();
//}
